export const WARPLANE_STATS_CONFIG = {
  "sourceWorkbook": "reference-data/aoz/aoz-fleet.xlsx",
  "sourceSheet": "Warplane - Stats",
  "extractedAt": "2026-03-11T02:01:52Z",
  "notes": [
    "Primary progression extracted from first contiguous Titan Level sequence starting at 1.",
    "Evolution fields are labeled Titan Tier Phase / Titan Tier Level in this sheet.",
    "Values are parsed directly from sheet cells; blanks omitted.",
    "Evolution timeline now includes phase/tier rows beyond the level block using carry-forward phase labels when sheet cells are blank."
  ],
  "levelProgression": [
    {
      "titanLevel": 1,
      "xp": 0,
      "xpCumulative": 0,
      "attack": 513600,
      "hp": 4356000,
      "defense": 37,
      "attackCumulative": 513600,
      "hpCumulative": 4356000,
      "defenseCumulative": 37,
      "attackIncreasePerLevel": 0,
      "titanTierPhase": "Green - Enforcer",
      "titanTierLevel": 0,
      "phaseAttack": 0,
      "phaseHp": 0,
      "phaseDefense": 0,
      "phaseAttackCumulative": 0,
      "phaseHpCumulative": 0,
      "phaseDefenseCumulative": 0,
      "phaseAndLevel": "Green - Enforcer:0"
    },
    {
      "titanLevel": 2,
      "xp": 300,
      "xpCumulative": 300,
      "attack": 46990,
      "hp": 435600,
      "defense": 5,
      "attackCumulative": 560590,
      "hpCumulative": 4791600,
      "defenseCumulative": 42,
      "attackIncreasePerLevel": -466610,
      "attackIncreaseRatePerLevel": 0.09149143302,
      "hpIncreaseRatePerLevel": 0.1,
      "titanTierPhase": "Green - Enforcer",
      "titanTierLevel": 1,
      "phaseAttack": 15512,
      "phaseHp": 250304,
      "phaseDefense": 1,
      "phaseAttackCumulative": 15512,
      "phaseHpCumulative": 250304,
      "phaseDefenseCumulative": 1,
      "phaseAndLevel": "Green - Enforcer:1"
    },
    {
      "titanLevel": 3,
      "xp": 900,
      "xpCumulative": 1200,
      "attack": 51290,
      "hp": 479160,
      "defense": 5,
      "attackCumulative": 611880,
      "hpCumulative": 5270760,
      "defenseCumulative": 47,
      "attackIncreasePerLevel": 4300,
      "attackIncreaseRatePerLevel": 0.09149289142,
      "hpIncreasePerLevel": 43560,
      "hpIncreaseRatePerLevel": 0.1,
      "titanTierPhase": "Green - Enforcer",
      "titanTierLevel": 2,
      "phaseAttack": 15512,
      "phaseHp": 250304,
      "phaseDefense": 1,
      "phaseAttackCumulative": 31024,
      "phaseHpCumulative": 500608,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Green - Enforcer:2"
    },
    {
      "titanLevel": 4,
      "xp": 1900,
      "xpCumulative": 3100,
      "attack": 55980,
      "hp": 527070,
      "defense": 5,
      "attackCumulative": 667860,
      "hpCumulative": 5797830,
      "defenseCumulative": 52,
      "attackIncreasePerLevel": 4690,
      "attackIncreaseRatePerLevel": 0.09148852716,
      "hpIncreasePerLevel": 47910,
      "hpIncreaseRatePerLevel": 0.09999886164,
      "titanTierPhase": "Green - Enforcer",
      "titanTierLevel": 3,
      "phaseAttack": 15512,
      "phaseHp": 250304,
      "phaseDefense": 1,
      "phaseAttackCumulative": 46536,
      "phaseHpCumulative": 750912,
      "phaseDefenseCumulative": 3,
      "phaseAndLevel": "Green - Enforcer:3"
    },
    {
      "titanLevel": 5,
      "xp": 3600,
      "xpCumulative": 6700,
      "attack": 61100,
      "hp": 579780,
      "defense": 5,
      "attackCumulative": 728960,
      "hpCumulative": 6377610,
      "defenseCumulative": 57,
      "attackIncreasePerLevel": 5120,
      "attackIncreaseRatePerLevel": 0.09148623963,
      "hpIncreasePerLevel": 52710,
      "hpIncreaseRatePerLevel": 0.09999948257,
      "titanTierPhase": "Green - Enforcer",
      "titanTierLevel": 4,
      "phaseAttack": 15512,
      "phaseHp": 250304,
      "phaseDefense": 1,
      "phaseAttackCumulative": 62048,
      "phaseHpCumulative": 1001216,
      "phaseDefenseCumulative": 4,
      "phaseAndLevel": "Green - Enforcer:4"
    },
    {
      "titanLevel": 6,
      "xp": 5400,
      "xpCumulative": 12100,
      "attack": 63050,
      "hp": 605870,
      "defense": 6,
      "attackCumulative": 792010,
      "hpCumulative": 6983480,
      "defenseCumulative": 63,
      "attackIncreasePerLevel": 1950,
      "attackIncreaseRatePerLevel": 0.08649308604,
      "hpIncreasePerLevel": 26090,
      "hpIncreaseRatePerLevel": 0.09499953744,
      "titanTierPhase": "Green - Enforcer",
      "titanTierLevel": 5,
      "phaseAttack": 15512,
      "phaseHp": 250304,
      "phaseDefense": 1,
      "phaseAttackCumulative": 77560,
      "phaseHpCumulative": 1251520,
      "phaseDefenseCumulative": 5,
      "phaseAndLevel": "Green - Enforcer:5"
    },
    {
      "titanLevel": 7,
      "xp": 7500,
      "xpCumulative": 19600,
      "attack": 68500,
      "hp": 663430,
      "defense": 6,
      "attackCumulative": 860510,
      "hpCumulative": 7646910,
      "defenseCumulative": 69,
      "attackIncreasePerLevel": 5450,
      "attackIncreaseRatePerLevel": 0.08648880696,
      "hpIncreasePerLevel": 57560,
      "hpIncreaseRatePerLevel": 0.09499991408,
      "titanTierPhase": "Green - Enforcer",
      "titanTierLevel": 6,
      "phaseAttack": 15512,
      "phaseHp": 250304,
      "phaseDefense": 1,
      "phaseAttackCumulative": 93072,
      "phaseHpCumulative": 1501824,
      "phaseDefenseCumulative": 6,
      "phaseAndLevel": "Green - Enforcer:6"
    },
    {
      "titanLevel": 8,
      "xp": 9900,
      "xpCumulative": 29500,
      "attack": 74420,
      "hp": 726460,
      "defense": 6,
      "attackCumulative": 934930,
      "hpCumulative": 8373370,
      "defenseCumulative": 75,
      "attackIncreasePerLevel": 5920,
      "attackIncreaseRatePerLevel": 0.08648359694,
      "hpIncreasePerLevel": 63030,
      "hpIncreaseRatePerLevel": 0.09500046424,
      "titanTierPhase": "Green - Enforcer",
      "titanTierLevel": 7,
      "phaseAttack": 15512,
      "phaseHp": 250304,
      "phaseDefense": 1,
      "phaseAttackCumulative": 108584,
      "phaseHpCumulative": 1752128,
      "phaseDefenseCumulative": 7,
      "phaseAndLevel": "Green - Enforcer:7"
    },
    {
      "titanLevel": 9,
      "xp": 12600,
      "xpCumulative": 42100,
      "attack": 80860,
      "hp": 795470,
      "defense": 6,
      "attackCumulative": 1015790,
      "hpCumulative": 9168840,
      "defenseCumulative": 81,
      "attackIncreasePerLevel": 6440,
      "attackIncreaseRatePerLevel": 0.08648775844,
      "hpIncreasePerLevel": 69010,
      "hpIncreaseRatePerLevel": 0.09499998209,
      "titanTierPhase": "Green - Enforcer",
      "titanTierLevel": 8,
      "phaseAttack": 15512,
      "phaseHp": 250304,
      "phaseDefense": 1,
      "phaseAttackCumulative": 124096,
      "phaseHpCumulative": 2002432,
      "phaseDefenseCumulative": 8,
      "phaseAndLevel": "Green - Enforcer:8"
    },
    {
      "titanLevel": 10,
      "xp": 15600,
      "xpCumulative": 57700,
      "attack": 82780,
      "hp": 825190,
      "defense": 6,
      "attackCumulative": 1098570,
      "hpCumulative": 9994030,
      "defenseCumulative": 87,
      "attackIncreasePerLevel": 1920,
      "attackIncreaseRatePerLevel": 0.08149322202,
      "hpIncreasePerLevel": 29720,
      "hpIncreaseRatePerLevel": 0.08999938924,
      "titanTierPhase": "Green - Enforcer",
      "titanTierLevel": 9,
      "phaseAttack": 15512,
      "phaseHp": 250304,
      "phaseDefense": 1,
      "phaseAttackCumulative": 139608,
      "phaseHpCumulative": 2252736,
      "phaseDefenseCumulative": 9,
      "phaseAndLevel": "Green - Enforcer:9"
    },
    {
      "titanLevel": 11,
      "xp": 19300,
      "xpCumulative": 77000,
      "defense": 7,
      "attackCumulative": 1098570,
      "hpCumulative": 9994030,
      "defenseCumulative": 94,
      "attackIncreasePerLevel": -82780,
      "attackIncreaseRatePerLevel": 0,
      "hpIncreasePerLevel": -825190,
      "hpIncreaseRatePerLevel": 0,
      "titanTierPhase": "Green - Explorer",
      "titanTierLevel": 0,
      "phaseAttack": 15512,
      "phaseHp": 250304,
      "phaseDefense": 1,
      "phaseAttackCumulative": 155120,
      "phaseHpCumulative": 2503040,
      "phaseDefenseCumulative": 10,
      "phaseAndLevel": "Green - Explorer:0"
    },
    {
      "titanLevel": 12,
      "xp": 23500,
      "xpCumulative": 100500,
      "attack": 96830,
      "hp": 980410,
      "defense": 7,
      "attackCumulative": 1195400,
      "hpCumulative": 10974440,
      "defenseCumulative": 101,
      "attackIncreasePerLevel": 96830,
      "attackIncreaseRatePerLevel": 0.08814185714,
      "hpIncreasePerLevel": 980410,
      "hpIncreaseRatePerLevel": 0.09809956544,
      "titanTierPhase": "Green - Explorer",
      "titanTierLevel": 1,
      "phaseAttack": 23268,
      "phaseHp": 375457,
      "phaseDefense": 1,
      "phaseAttackCumulative": 178388,
      "phaseHpCumulative": 2878497,
      "phaseDefenseCumulative": 11,
      "phaseAndLevel": "Green - Explorer:1"
    },
    {
      "titanLevel": 13,
      "xp": 28300,
      "xpCumulative": 128800,
      "defense": 7,
      "attackCumulative": 1195400,
      "hpCumulative": 10974440,
      "defenseCumulative": 108,
      "attackIncreasePerLevel": -96830,
      "attackIncreaseRatePerLevel": 0,
      "hpIncreasePerLevel": -980410,
      "hpIncreaseRatePerLevel": 0,
      "titanTierPhase": "Green - Explorer",
      "titanTierLevel": 2,
      "phaseAttack": 23268,
      "phaseHp": 375457,
      "phaseDefense": 1,
      "phaseAttackCumulative": 201656,
      "phaseHpCumulative": 3253954,
      "phaseDefenseCumulative": 12,
      "phaseAndLevel": "Green - Explorer:2"
    },
    {
      "titanLevel": 14,
      "xp": 33600,
      "xpCumulative": 162400,
      "defense": 7,
      "attackCumulative": 1195400,
      "hpCumulative": 10974440,
      "defenseCumulative": 115,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0,
      "titanTierPhase": "Green - Explorer",
      "titanTierLevel": 3,
      "phaseAttack": 23268,
      "phaseHp": 375457,
      "phaseDefense": 1,
      "phaseAttackCumulative": 224924,
      "phaseHpCumulative": 3629411,
      "phaseDefenseCumulative": 13,
      "phaseAndLevel": "Green - Explorer:3"
    },
    {
      "titanLevel": 15,
      "xp": 39500,
      "xpCumulative": 201900,
      "defense": 7,
      "attackCumulative": 1195400,
      "hpCumulative": 10974440,
      "defenseCumulative": 122,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0,
      "titanTierPhase": "Green - Explorer",
      "titanTierLevel": 4,
      "phaseAttack": 23268,
      "phaseHp": 375457,
      "phaseDefense": 1,
      "phaseAttackCumulative": 248192,
      "phaseHpCumulative": 4004868,
      "phaseDefenseCumulative": 14,
      "phaseAndLevel": "Green - Explorer:4"
    },
    {
      "titanLevel": 16,
      "xp": 46200,
      "xpCumulative": 248100,
      "attack": 538200,
      "hp": 5556890,
      "defense": 8,
      "attackCumulative": 1733600,
      "hpCumulative": 16531330,
      "defenseCumulative": 130,
      "attackIncreasePerLevel": 538200,
      "attackIncreaseRatePerLevel": 0.4502258658,
      "hpIncreasePerLevel": 5556890,
      "hpIncreaseRatePerLevel": 0.5063483877,
      "titanTierPhase": "Green - Explorer",
      "titanTierLevel": 5,
      "phaseAttack": 23268,
      "phaseHp": 375457,
      "phaseDefense": 1,
      "phaseAttackCumulative": 271460,
      "phaseHpCumulative": 4380325,
      "phaseDefenseCumulative": 15,
      "phaseAndLevel": "Green - Explorer:5"
    },
    {
      "titanLevel": 17,
      "xp": 55000,
      "xpCumulative": 303100,
      "attack": 132620,
      "hp": 1405160,
      "defense": 8,
      "attackCumulative": 1866220,
      "hpCumulative": 17936490,
      "defenseCumulative": 138,
      "attackIncreasePerLevel": -405580,
      "attackIncreaseRatePerLevel": 0.07649976927,
      "hpIncreasePerLevel": -4151730,
      "hpIncreaseRatePerLevel": 0.0849998155,
      "titanTierPhase": "Green - Explorer",
      "titanTierLevel": 6,
      "phaseAttack": 23268,
      "phaseHp": 375457,
      "phaseDefense": 1,
      "phaseAttackCumulative": 294728,
      "phaseHpCumulative": 4755782,
      "phaseDefenseCumulative": 16,
      "phaseAndLevel": "Green - Explorer:6"
    },
    {
      "titanLevel": 18,
      "xp": 65300,
      "xpCumulative": 368400,
      "attack": 133430,
      "hp": 1434910,
      "defense": 8,
      "attackCumulative": 1999650,
      "hpCumulative": 19371400,
      "defenseCumulative": 146,
      "attackIncreasePerLevel": 810,
      "attackIncreaseRatePerLevel": 0.07149746546,
      "hpIncreasePerLevel": 29750,
      "hpIncreaseRatePerLevel": 0.07999948708,
      "titanTierPhase": "Green - Explorer",
      "titanTierLevel": 7,
      "phaseAttack": 23268,
      "phaseHp": 375457,
      "phaseDefense": 1,
      "phaseAttackCumulative": 317996,
      "phaseHpCumulative": 5131239,
      "phaseDefenseCumulative": 17,
      "phaseAndLevel": "Green - Explorer:7"
    },
    {
      "titanLevel": 19,
      "xp": 77100,
      "xpCumulative": 445500,
      "attack": 142970,
      "hp": 1549710,
      "defense": 8,
      "attackCumulative": 2142620,
      "hpCumulative": 20921110,
      "defenseCumulative": 154,
      "attackIncreasePerLevel": 9540,
      "attackIncreaseRatePerLevel": 0.07149751206,
      "hpIncreasePerLevel": 114800,
      "hpIncreaseRatePerLevel": 0.07999989676,
      "titanTierPhase": "Green - Explorer",
      "titanTierLevel": 8,
      "phaseAttack": 23268,
      "phaseHp": 375457,
      "phaseDefense": 1,
      "phaseAttackCumulative": 341264,
      "phaseHpCumulative": 5506696,
      "phaseDefenseCumulative": 18,
      "phaseAndLevel": "Green - Explorer:8"
    },
    {
      "titanLevel": 20,
      "xp": 90700,
      "xpCumulative": 536200,
      "attack": 153190,
      "hp": 1673680,
      "defense": 8,
      "attackCumulative": 2295810,
      "hpCumulative": 22594790,
      "defenseCumulative": 162,
      "attackIncreasePerLevel": 10220,
      "attackIncreaseRatePerLevel": 0.07149657895,
      "hpIncreasePerLevel": 123970,
      "hpIncreaseRatePerLevel": 0.07999957937,
      "titanTierPhase": "Green - Explorer",
      "titanTierLevel": 9,
      "phaseAttack": 23268,
      "phaseHp": 375457,
      "phaseDefense": 1,
      "phaseAttackCumulative": 364532,
      "phaseHpCumulative": 5882153,
      "phaseDefenseCumulative": 19,
      "phaseAndLevel": "Green - Explorer:9"
    },
    {
      "titanLevel": 21,
      "xp": 106400,
      "xpCumulative": 642600,
      "attack": 160150,
      "hp": 1807580,
      "defense": 9,
      "attackCumulative": 2455960,
      "hpCumulative": 24402370,
      "defenseCumulative": 171,
      "attackIncreasePerLevel": 6960,
      "attackIncreaseRatePerLevel": 0.06975751478,
      "hpIncreasePerLevel": 133900,
      "hpIncreaseRatePerLevel": 0.07999985837,
      "titanTierPhase": "Blue - Guardian",
      "titanTierLevel": 0,
      "phaseAttack": 23268,
      "phaseHp": 375457,
      "phaseDefense": 1,
      "phaseAttackCumulative": 387800,
      "phaseHpCumulative": 6257610,
      "phaseDefenseCumulative": 20,
      "phaseAndLevel": "Blue - Guardian:0"
    },
    {
      "titanLevel": 22,
      "xp": 124400,
      "xpCumulative": 767000,
      "attack": 163320,
      "hp": 1830170,
      "defense": 9,
      "attackCumulative": 2619280,
      "hpCumulative": 26232540,
      "defenseCumulative": 180,
      "attackIncreasePerLevel": 3170,
      "attackIncreaseRatePerLevel": 0.06649945439,
      "hpIncreasePerLevel": 22590,
      "hpIncreaseRatePerLevel": 0.07499968241,
      "titanTierPhase": "Blue - Guardian",
      "titanTierLevel": 1,
      "phaseAttack": 32317,
      "phaseHp": 521468,
      "phaseDefense": 2,
      "phaseAttackCumulative": 420117,
      "phaseHpCumulative": 6779078,
      "phaseDefenseCumulative": 22,
      "phaseAndLevel": "Blue - Guardian:1"
    },
    {
      "titanLevel": 23,
      "xp": 145200,
      "xpCumulative": 912200,
      "attack": 178720,
      "hp": 1967440,
      "defense": 10,
      "attackCumulative": 2798000,
      "hpCumulative": 28199980,
      "defenseCumulative": 190,
      "attackIncreasePerLevel": 15400,
      "attackIncreaseRatePerLevel": 0.06823249137,
      "hpIncreasePerLevel": 137270,
      "hpIncreaseRatePerLevel": 0.07499998094,
      "titanTierPhase": "Blue - Guardian",
      "titanTierLevel": 2,
      "phaseAttack": 32317,
      "phaseHp": 521468,
      "phaseDefense": 2,
      "phaseAttackCumulative": 452434,
      "phaseHpCumulative": 7300546,
      "phaseDefenseCumulative": 24,
      "phaseAndLevel": "Blue - Guardian:2"
    },
    {
      "titanLevel": 24,
      "xp": 168900,
      "xpCumulative": 1081100,
      "attack": 186060,
      "hp": 2114990,
      "defense": 10,
      "attackCumulative": 2984060,
      "hpCumulative": 30314970,
      "defenseCumulative": 200,
      "attackIncreasePerLevel": 7340,
      "attackIncreaseRatePerLevel": 0.06649749821,
      "hpIncreasePerLevel": 147550,
      "hpIncreaseRatePerLevel": 0.07499969858,
      "titanTierPhase": "Blue - Guardian",
      "titanTierLevel": 3,
      "phaseAttack": 32317,
      "phaseHp": 521468,
      "phaseDefense": 2,
      "phaseAttackCumulative": 484751,
      "phaseHpCumulative": 7822014,
      "phaseDefenseCumulative": 26,
      "phaseAndLevel": "Blue - Guardian:3"
    },
    {
      "titanLevel": 25,
      "xp": 196200,
      "xpCumulative": 1277300,
      "attack": 198430,
      "hp": 2273620,
      "defense": 10,
      "attackCumulative": 3182490,
      "hpCumulative": 32588590,
      "defenseCumulative": 210,
      "attackIncreasePerLevel": 12370,
      "attackIncreaseRatePerLevel": 0.06649665221,
      "hpIncreasePerLevel": 158630,
      "hpIncreaseRatePerLevel": 0.07499990929,
      "titanTierPhase": "Blue - Guardian",
      "titanTierLevel": 4,
      "phaseAttack": 32317,
      "phaseHp": 521468,
      "phaseDefense": 1,
      "phaseAttackCumulative": 517068,
      "phaseHpCumulative": 8343482,
      "phaseDefenseCumulative": 27,
      "phaseAndLevel": "Blue - Guardian:4"
    },
    {
      "titanLevel": 26,
      "xp": 227400,
      "xpCumulative": 1504700,
      "attack": 195720,
      "hp": 2281200,
      "defense": 10,
      "attackCumulative": 3378210,
      "hpCumulative": 34869790,
      "defenseCumulative": 220,
      "attackIncreasePerLevel": -2710,
      "attackIncreaseRatePerLevel": 0.06149901492,
      "hpIncreasePerLevel": 7580,
      "hpIncreaseRatePerLevel": 0.06999996011,
      "titanTierPhase": "Blue - Guardian",
      "titanTierLevel": 5,
      "phaseAttack": 32317,
      "phaseHp": 521468,
      "phaseDefense": 2,
      "phaseAttackCumulative": 549385,
      "phaseHpCumulative": 8864950,
      "phaseDefenseCumulative": 29,
      "phaseAndLevel": "Blue - Guardian:5"
    },
    {
      "titanLevel": 27,
      "xp": 263100,
      "xpCumulative": 1767800,
      "attack": 207750,
      "hp": 2440880,
      "defense": 10,
      "attackCumulative": 3585960,
      "hpCumulative": 37310670,
      "defenseCumulative": 230,
      "attackIncreasePerLevel": 12030,
      "attackIncreaseRatePerLevel": 0.06149706501,
      "hpIncreasePerLevel": 159680,
      "hpIncreaseRatePerLevel": 0.06999984801,
      "titanTierPhase": "Blue - Guardian",
      "titanTierLevel": 6,
      "phaseAttack": 32317,
      "phaseHp": 521468,
      "phaseDefense": 1,
      "phaseAttackCumulative": 581702,
      "phaseHpCumulative": 9386418,
      "phaseDefenseCumulative": 30,
      "phaseAndLevel": "Blue - Guardian:6"
    },
    {
      "titanLevel": 28,
      "xp": 304000,
      "xpCumulative": 2071800,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 3806490,
      "hpCumulative": 39922410,
      "defenseCumulative": 240,
      "attackIncreasePerLevel": 12780,
      "attackIncreaseRatePerLevel": 0.06149817622,
      "hpIncreasePerLevel": 170860,
      "hpIncreaseRatePerLevel": 0.06999981507,
      "titanTierPhase": "Blue - Guardian",
      "titanTierLevel": 7,
      "phaseAttack": 32317,
      "phaseHp": 521468,
      "phaseDefense": 1,
      "phaseAttackCumulative": 614019,
      "phaseHpCumulative": 9907886,
      "phaseDefenseCumulative": 31,
      "phaseAndLevel": "Blue - Guardian:7"
    },
    {
      "titanLevel": 29,
      "xp": 350800,
      "xpCumulative": 2422600,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 4027020,
      "hpCumulative": 42534150,
      "defenseCumulative": 250,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.0579352632,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.06542039922,
      "titanTierPhase": "Blue - Guardian",
      "titanTierLevel": 8,
      "phaseAttack": 32317,
      "phaseHp": 521468,
      "phaseDefense": 1,
      "phaseAttackCumulative": 646336,
      "phaseHpCumulative": 10429354,
      "phaseDefenseCumulative": 32,
      "phaseAndLevel": "Blue - Guardian:8"
    },
    {
      "titanLevel": 30,
      "xp": 404200,
      "xpCumulative": 2826800,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 4247550,
      "hpCumulative": 45145890,
      "defenseCumulative": 260,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.05476257878,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.06140336647,
      "titanTierPhase": "Blue - Guardian",
      "titanTierLevel": 9,
      "phaseAttack": 32317,
      "phaseHp": 521468,
      "phaseDefense": 1,
      "phaseAttackCumulative": 678653,
      "phaseHpCumulative": 10950822,
      "phaseDefenseCumulative": 33,
      "phaseAndLevel": "Blue - Guardian:9"
    },
    {
      "titanLevel": 31,
      "xp": 465200,
      "xpCumulative": 3292000,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 4468080,
      "hpCumulative": 47757630,
      "defenseCumulative": 270,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.05191934174,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.05785111336,
      "titanTierPhase": "Blue - Lacerator",
      "titanTierLevel": 0,
      "phaseAttack": 32317,
      "phaseHp": 521468,
      "phaseDefense": 1,
      "phaseAttackCumulative": 710970,
      "phaseHpCumulative": 11472290,
      "phaseDefenseCumulative": 34,
      "phaseAndLevel": "Blue - Lacerator:0"
    },
    {
      "titanLevel": 32,
      "xp": 516800,
      "xpCumulative": 3808800,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 4688610,
      "hpCumulative": 50369370,
      "defenseCumulative": 280,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.04935677069,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.05468738713,
      "titanTierPhase": "Blue - Lacerator",
      "titanTierLevel": 1,
      "phaseAttack": 38780,
      "phaseHp": 625762,
      "phaseDefense": 1,
      "phaseAttackCumulative": 749750,
      "phaseHpCumulative": 12098052,
      "phaseDefenseCumulative": 35,
      "phaseAndLevel": "Blue - Lacerator:1"
    },
    {
      "titanLevel": 33,
      "xp": 553700,
      "xpCumulative": 4362500,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 4909140,
      "hpCumulative": 52981110,
      "defenseCumulative": 290,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.04703526205,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.05185175038,
      "titanTierPhase": "Blue - Lacerator",
      "titanTierLevel": 2,
      "phaseAttack": 38780,
      "phaseHp": 625762,
      "phaseDefense": 1,
      "phaseAttackCumulative": 788530,
      "phaseHpCumulative": 12723814,
      "phaseDefenseCumulative": 36,
      "phaseAndLevel": "Blue - Lacerator:2"
    },
    {
      "titanLevel": 34,
      "xp": 591900,
      "xpCumulative": 4954400,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 5129670,
      "hpCumulative": 55592850,
      "defenseCumulative": 300,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.04492232855,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.04929568293,
      "titanTierPhase": "Blue - Lacerator",
      "titanTierLevel": 3,
      "phaseAttack": 38780,
      "phaseHp": 625762,
      "phaseDefense": 1,
      "phaseAttackCumulative": 827310,
      "phaseHpCumulative": 13349576,
      "phaseDefenseCumulative": 37,
      "phaseAndLevel": "Blue - Lacerator:3"
    },
    {
      "titanLevel": 35,
      "xp": 631500,
      "xpCumulative": 5585900,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 5350200,
      "hpCumulative": 58204590,
      "defenseCumulative": 310,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.0429910696,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.04697978247,
      "titanTierPhase": "Blue - Lacerator",
      "titanTierLevel": 4,
      "phaseAttack": 38780,
      "phaseHp": 625762,
      "phaseDefense": 2,
      "phaseAttackCumulative": 866090,
      "phaseHpCumulative": 13975338,
      "phaseDefenseCumulative": 39,
      "phaseAndLevel": "Blue - Lacerator:4"
    },
    {
      "titanLevel": 36,
      "xp": 672500,
      "xpCumulative": 6258400,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 5570730,
      "hpCumulative": 60816330,
      "defenseCumulative": 320,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.04121901985,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.04487171888,
      "titanTierPhase": "Blue - Lacerator",
      "titanTierLevel": 5,
      "phaseAttack": 38780,
      "phaseHp": 625762,
      "phaseDefense": 2,
      "phaseAttackCumulative": 904870,
      "phaseHpCumulative": 14601100,
      "phaseDefenseCumulative": 41,
      "phaseAndLevel": "Blue - Lacerator:5"
    },
    {
      "titanLevel": 37,
      "xp": 714900,
      "xpCumulative": 6973300,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 5791260,
      "hpCumulative": 63428070,
      "defenseCumulative": 330,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.03958727133,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.04294471567,
      "titanTierPhase": "Blue - Lacerator",
      "titanTierLevel": 6,
      "phaseAttack": 38780,
      "phaseHp": 625762,
      "phaseDefense": 2,
      "phaseAttackCumulative": 943650,
      "phaseHpCumulative": 15226862,
      "phaseDefenseCumulative": 43,
      "phaseAndLevel": "Blue - Lacerator:6"
    },
    {
      "titanLevel": 38,
      "xp": 758700,
      "xpCumulative": 7732000,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 6011790,
      "hpCumulative": 66039810,
      "defenseCumulative": 340,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.03807979611,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.0411764066,
      "titanTierPhase": "Blue - Lacerator",
      "titanTierLevel": 7,
      "phaseAttack": 38780,
      "phaseHp": 625762,
      "phaseDefense": 2,
      "phaseAttackCumulative": 982430,
      "phaseHpCumulative": 15852624,
      "phaseDefenseCumulative": 45,
      "phaseAndLevel": "Blue - Lacerator:7"
    },
    {
      "titanLevel": 39,
      "xp": 803900,
      "xpCumulative": 8535900,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 6232320,
      "hpCumulative": 68651550,
      "defenseCumulative": 350,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.03668291807,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.03954796357,
      "titanTierPhase": "Blue - Lacerator",
      "titanTierLevel": 8,
      "phaseAttack": 38780,
      "phaseHp": 625762,
      "phaseDefense": 1,
      "phaseAttackCumulative": 1021210,
      "phaseHpCumulative": 16478386,
      "phaseDefenseCumulative": 46,
      "phaseAndLevel": "Blue - Lacerator:8"
    },
    {
      "titanLevel": 40,
      "xpCumulative": 8535900,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 6452850,
      "hpCumulative": 71263290,
      "defenseCumulative": 360,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.0353848968,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.03804342364,
      "titanTierPhase": "Blue - Lacerator",
      "titanTierLevel": 9,
      "phaseAttack": 38780,
      "phaseHp": 625762,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1059990,
      "phaseHpCumulative": 17104148,
      "phaseDefenseCumulative": 48,
      "phaseAndLevel": "Blue - Lacerator:9"
    },
    {
      "titanLevel": 41,
      "xpCumulative": 8535900,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 6673380,
      "hpCumulative": 73875030,
      "defenseCumulative": 370,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.03417559683,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.03664916397,
      "titanTierPhase": "Purple - Trailblazer",
      "titanTierLevel": 0,
      "phaseAttack": 38780,
      "phaseHp": 625762,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1098770,
      "phaseHpCumulative": 17729910,
      "phaseDefenseCumulative": 50,
      "phaseAndLevel": "Purple - Trailblazer:0"
    },
    {
      "titanLevel": 42,
      "xpCumulative": 8535900,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 6893910,
      "hpCumulative": 76486770,
      "defenseCumulative": 380,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.03304622245,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.03535348818,
      "titanTierPhase": "Purple - Trailblazer",
      "titanTierLevel": 1,
      "phaseAttack": 45244,
      "phaseHp": 730055,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1144014,
      "phaseHpCumulative": 18459965,
      "phaseDefenseCumulative": 52,
      "phaseAndLevel": "Purple - Trailblazer:1"
    },
    {
      "titanLevel": 43,
      "xpCumulative": 8535900,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 7114440,
      "hpCumulative": 79098510,
      "defenseCumulative": 390,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.03198910343,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.03414629746,
      "titanTierPhase": "Purple - Trailblazer",
      "titanTierLevel": 2,
      "phaseAttack": 45244,
      "phaseHp": 730055,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1189258,
      "phaseHpCumulative": 19190020,
      "phaseDefenseCumulative": 54,
      "phaseAndLevel": "Purple - Trailblazer:2"
    },
    {
      "titanLevel": 44,
      "xpCumulative": 8535900,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 7334970,
      "hpCumulative": 81710250,
      "defenseCumulative": 400,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.03099752054,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.03301882678,
      "titanTierPhase": "Purple - Trailblazer",
      "titanTierLevel": 3,
      "phaseAttack": 45244,
      "phaseHp": 730055,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1234502,
      "phaseHpCumulative": 19920075,
      "phaseDefenseCumulative": 56,
      "phaseAndLevel": "Purple - Trailblazer:3"
    },
    {
      "titanLevel": 45,
      "xpCumulative": 8535900,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 7555500,
      "hpCumulative": 84321990,
      "defenseCumulative": 410,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.03006556264,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.03196343176,
      "titanTierPhase": "Purple - Trailblazer",
      "titanTierLevel": 4,
      "phaseAttack": 45244,
      "phaseHp": 730055,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1279746,
      "phaseHpCumulative": 20650130,
      "phaseDefenseCumulative": 58,
      "phaseAndLevel": "Purple - Trailblazer:4"
    },
    {
      "titanLevel": 46,
      "xpCumulative": 8535900,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 7776030,
      "hpCumulative": 86933730,
      "defenseCumulative": 420,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.02918800874,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.03097341512,
      "titanTierPhase": "Purple - Trailblazer",
      "titanTierLevel": 5,
      "phaseAttack": 45244,
      "phaseHp": 730055,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1324990,
      "phaseHpCumulative": 21380185,
      "phaseDefenseCumulative": 60,
      "phaseAndLevel": "Purple - Trailblazer:5"
    },
    {
      "titanLevel": 47,
      "xpCumulative": 8535900,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 7996560,
      "hpCumulative": 89545470,
      "defenseCumulative": 430,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.02836023009,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.03004288439,
      "titanTierPhase": "Purple - Trailblazer",
      "titanTierLevel": 6,
      "phaseAttack": 45244,
      "phaseHp": 730055,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1370234,
      "phaseHpCumulative": 22110240,
      "phaseDefenseCumulative": 62,
      "phaseAndLevel": "Purple - Trailblazer:6"
    },
    {
      "titanLevel": 48,
      "xpCumulative": 8535900,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 8217090,
      "hpCumulative": 92157210,
      "defenseCumulative": 440,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.02757810859,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.02916663456,
      "titanTierPhase": "Purple - Trailblazer",
      "titanTierLevel": 7,
      "phaseAttack": 45244,
      "phaseHp": 730055,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1415478,
      "phaseHpCumulative": 22840295,
      "phaseDefenseCumulative": 64,
      "phaseAndLevel": "Purple - Trailblazer:7"
    },
    {
      "titanLevel": 49,
      "xp": 1334700,
      "xpCumulative": 9870600,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 8437620,
      "hpCumulative": 94768950,
      "defenseCumulative": 450,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.02683796819,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.02834005066,
      "titanTierPhase": "Purple - Trailblazer",
      "titanTierLevel": 8,
      "phaseAttack": 45244,
      "phaseHp": 730055,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1460722,
      "phaseHpCumulative": 23570350,
      "phaseDefenseCumulative": 66,
      "phaseAndLevel": "Purple - Trailblazer:8"
    },
    {
      "titanLevel": 50,
      "xp": 1395800,
      "xpCumulative": 11266400,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 8658150,
      "hpCumulative": 97380690,
      "defenseCumulative": 460,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.02613651717,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.02755902645,
      "titanTierPhase": "Purple - Trailblazer",
      "titanTierLevel": 9,
      "phaseAttack": 45244,
      "phaseHp": 730055,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1505966,
      "phaseHpCumulative": 24300405,
      "phaseDefenseCumulative": 68,
      "phaseAndLevel": "Purple - Trailblazer:9"
    },
    {
      "titanLevel": 51,
      "xpCumulative": 11266400,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 8878680,
      "hpCumulative": 99992430,
      "defenseCumulative": 470,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.02547079919,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.02681989622,
      "titanTierPhase": "Purple - Inquisitor",
      "titanTierLevel": 0,
      "phaseAttack": 45244,
      "phaseHp": 730055,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1551210,
      "phaseHpCumulative": 25030460,
      "phaseDefenseCumulative": 70,
      "phaseAndLevel": "Purple - Inquisitor:0"
    },
    {
      "titanLevel": 52,
      "xpCumulative": 11266400,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 9099210,
      "hpCumulative": 102604170,
      "defenseCumulative": 480,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.02483815162,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.02611937724,
      "titanTierPhase": "Purple - Inquisitor",
      "titanTierLevel": 1,
      "phaseAttack": 51707,
      "phaseHp": 834349,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1602917,
      "phaseHpCumulative": 25864809,
      "phaseDefenseCumulative": 72,
      "phaseAndLevel": "Purple - Inquisitor:1"
    },
    {
      "titanLevel": 53,
      "xpCumulative": 11266400,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 9319740,
      "hpCumulative": 105215910,
      "defenseCumulative": 490,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.02423616995,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.025454521,
      "titanTierPhase": "Purple - Inquisitor",
      "titanTierLevel": 2,
      "phaseAttack": 51707,
      "phaseHp": 834349,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1654624,
      "phaseHpCumulative": 26699158,
      "phaseDefenseCumulative": 74,
      "phaseAndLevel": "Purple - Inquisitor:2"
    },
    {
      "titanLevel": 54,
      "xpCumulative": 11266400,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 9540270,
      "hpCumulative": 107827650,
      "defenseCumulative": 500,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.02366267728,
      "hpIncreasePerLevel": 0,
      "hpIncreaseRatePerLevel": 0.02482267178,
      "titanTierPhase": "Purple - Inquisitor",
      "titanTierLevel": 3,
      "phaseAttack": 51707,
      "phaseHp": 834349,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1706331,
      "phaseHpCumulative": 27533507,
      "phaseDefenseCumulative": 76,
      "phaseAndLevel": "Purple - Inquisitor:3"
    },
    {
      "titanLevel": 55,
      "xpCumulative": 11266400,
      "attack": 220530,
      "hp": 2611740,
      "defense": 10,
      "attackCumulative": 9760800,
      "hpCumulative": 110439390,
      "defenseCumulative": 510,
      "attackIncreasePerLevel": 0,
      "attackIncreaseRatePerLevel": 0.02311569798,
      "hpIncreaseRatePerLevel": 0.02422143114,
      "titanTierPhase": "Purple - Inquisitor",
      "titanTierLevel": 4,
      "phaseAttack": 51707,
      "phaseHp": 834349,
      "phaseDefense": 2,
      "phaseAttackCumulative": 1758038,
      "phaseHpCumulative": 28367856,
      "phaseDefenseCumulative": 78,
      "phaseAndLevel": "Purple - Inquisitor:4"
    }
  ],
  "evolution": {
    "phaseField": "titanTierPhase",
    "evolutionLevelField": "titanTierLevel",
    "timeline": [
      {
        "sheetRow": 2,
        "phase": "Green - Enforcer",
        "evolutionLevel": 0,
        "phaseAndLevel": "Green - Enforcer:0",
        "titanLevel": 1,
        "phaseAttack": 0,
        "phaseHp": 0,
        "phaseDefense": 0,
        "phaseAttackCumulative": 0,
        "phaseHpCumulative": 0,
        "phaseDefenseCumulative": 0
      },
      {
        "sheetRow": 3,
        "phase": "Green - Enforcer",
        "evolutionLevel": 1,
        "phaseAndLevel": "Green - Enforcer:1",
        "titanLevel": 2,
        "phaseAttack": 15512,
        "phaseHp": 250304,
        "phaseDefense": 1,
        "phaseAttackCumulative": 15512,
        "phaseHpCumulative": 250304,
        "phaseDefenseCumulative": 1
      },
      {
        "sheetRow": 4,
        "phase": "Green - Enforcer",
        "evolutionLevel": 2,
        "phaseAndLevel": "Green - Enforcer:2",
        "titanLevel": 3,
        "phaseAttack": 15512,
        "phaseHp": 250304,
        "phaseDefense": 1,
        "phaseAttackCumulative": 31024,
        "phaseHpCumulative": 500608,
        "phaseDefenseCumulative": 2
      },
      {
        "sheetRow": 5,
        "phase": "Green - Enforcer",
        "evolutionLevel": 3,
        "phaseAndLevel": "Green - Enforcer:3",
        "titanLevel": 4,
        "phaseAttack": 15512,
        "phaseHp": 250304,
        "phaseDefense": 1,
        "phaseAttackCumulative": 46536,
        "phaseHpCumulative": 750912,
        "phaseDefenseCumulative": 3
      },
      {
        "sheetRow": 6,
        "phase": "Green - Enforcer",
        "evolutionLevel": 4,
        "phaseAndLevel": "Green - Enforcer:4",
        "titanLevel": 5,
        "phaseAttack": 15512,
        "phaseHp": 250304,
        "phaseDefense": 1,
        "phaseAttackCumulative": 62048,
        "phaseHpCumulative": 1001216,
        "phaseDefenseCumulative": 4
      },
      {
        "sheetRow": 7,
        "phase": "Green - Enforcer",
        "evolutionLevel": 5,
        "phaseAndLevel": "Green - Enforcer:5",
        "titanLevel": 6,
        "phaseAttack": 15512,
        "phaseHp": 250304,
        "phaseDefense": 1,
        "phaseAttackCumulative": 77560,
        "phaseHpCumulative": 1251520,
        "phaseDefenseCumulative": 5
      },
      {
        "sheetRow": 8,
        "phase": "Green - Enforcer",
        "evolutionLevel": 6,
        "phaseAndLevel": "Green - Enforcer:6",
        "titanLevel": 7,
        "phaseAttack": 15512,
        "phaseHp": 250304,
        "phaseDefense": 1,
        "phaseAttackCumulative": 93072,
        "phaseHpCumulative": 1501824,
        "phaseDefenseCumulative": 6
      },
      {
        "sheetRow": 9,
        "phase": "Green - Enforcer",
        "evolutionLevel": 7,
        "phaseAndLevel": "Green - Enforcer:7",
        "titanLevel": 8,
        "phaseAttack": 15512,
        "phaseHp": 250304,
        "phaseDefense": 1,
        "phaseAttackCumulative": 108584,
        "phaseHpCumulative": 1752128,
        "phaseDefenseCumulative": 7
      },
      {
        "sheetRow": 10,
        "phase": "Green - Enforcer",
        "evolutionLevel": 8,
        "phaseAndLevel": "Green - Enforcer:8",
        "titanLevel": 9,
        "phaseAttack": 15512,
        "phaseHp": 250304,
        "phaseDefense": 1,
        "phaseAttackCumulative": 124096,
        "phaseHpCumulative": 2002432,
        "phaseDefenseCumulative": 8
      },
      {
        "sheetRow": 11,
        "phase": "Green - Enforcer",
        "evolutionLevel": 9,
        "phaseAndLevel": "Green - Enforcer:9",
        "titanLevel": 10,
        "phaseAttack": 15512,
        "phaseHp": 250304,
        "phaseDefense": 1,
        "phaseAttackCumulative": 139608,
        "phaseHpCumulative": 2252736,
        "phaseDefenseCumulative": 9
      },
      {
        "sheetRow": 12,
        "phase": "Green - Explorer",
        "evolutionLevel": 0,
        "phaseAndLevel": "Green - Explorer:0",
        "titanLevel": 11,
        "phaseAttack": 15512,
        "phaseHp": 250304,
        "phaseDefense": 1,
        "phaseAttackCumulative": 155120,
        "phaseHpCumulative": 2503040,
        "phaseDefenseCumulative": 10
      },
      {
        "sheetRow": 13,
        "phase": "Green - Explorer",
        "evolutionLevel": 1,
        "phaseAndLevel": "Green - Explorer:1",
        "titanLevel": 12,
        "phaseAttack": 23268,
        "phaseHp": 375457,
        "phaseDefense": 1,
        "phaseAttackCumulative": 178388,
        "phaseHpCumulative": 2878497,
        "phaseDefenseCumulative": 11
      },
      {
        "sheetRow": 14,
        "phase": "Green - Explorer",
        "evolutionLevel": 2,
        "phaseAndLevel": "Green - Explorer:2",
        "titanLevel": 13,
        "phaseAttack": 23268,
        "phaseHp": 375457,
        "phaseDefense": 1,
        "phaseAttackCumulative": 201656,
        "phaseHpCumulative": 3253954,
        "phaseDefenseCumulative": 12
      },
      {
        "sheetRow": 15,
        "phase": "Green - Explorer",
        "evolutionLevel": 3,
        "phaseAndLevel": "Green - Explorer:3",
        "titanLevel": 14,
        "phaseAttack": 23268,
        "phaseHp": 375457,
        "phaseDefense": 1,
        "phaseAttackCumulative": 224924,
        "phaseHpCumulative": 3629411,
        "phaseDefenseCumulative": 13
      },
      {
        "sheetRow": 16,
        "phase": "Green - Explorer",
        "evolutionLevel": 4,
        "phaseAndLevel": "Green - Explorer:4",
        "titanLevel": 15,
        "phaseAttack": 23268,
        "phaseHp": 375457,
        "phaseDefense": 1,
        "phaseAttackCumulative": 248192,
        "phaseHpCumulative": 4004868,
        "phaseDefenseCumulative": 14
      },
      {
        "sheetRow": 17,
        "phase": "Green - Explorer",
        "evolutionLevel": 5,
        "phaseAndLevel": "Green - Explorer:5",
        "titanLevel": 16,
        "phaseAttack": 23268,
        "phaseHp": 375457,
        "phaseDefense": 1,
        "phaseAttackCumulative": 271460,
        "phaseHpCumulative": 4380325,
        "phaseDefenseCumulative": 15
      },
      {
        "sheetRow": 18,
        "phase": "Green - Explorer",
        "evolutionLevel": 6,
        "phaseAndLevel": "Green - Explorer:6",
        "titanLevel": 17,
        "phaseAttack": 23268,
        "phaseHp": 375457,
        "phaseDefense": 1,
        "phaseAttackCumulative": 294728,
        "phaseHpCumulative": 4755782,
        "phaseDefenseCumulative": 16
      },
      {
        "sheetRow": 19,
        "phase": "Green - Explorer",
        "evolutionLevel": 7,
        "phaseAndLevel": "Green - Explorer:7",
        "titanLevel": 18,
        "phaseAttack": 23268,
        "phaseHp": 375457,
        "phaseDefense": 1,
        "phaseAttackCumulative": 317996,
        "phaseHpCumulative": 5131239,
        "phaseDefenseCumulative": 17
      },
      {
        "sheetRow": 20,
        "phase": "Green - Explorer",
        "evolutionLevel": 8,
        "phaseAndLevel": "Green - Explorer:8",
        "titanLevel": 19,
        "phaseAttack": 23268,
        "phaseHp": 375457,
        "phaseDefense": 1,
        "phaseAttackCumulative": 341264,
        "phaseHpCumulative": 5506696,
        "phaseDefenseCumulative": 18
      },
      {
        "sheetRow": 21,
        "phase": "Green - Explorer",
        "evolutionLevel": 9,
        "phaseAndLevel": "Green - Explorer:9",
        "titanLevel": 20,
        "phaseAttack": 23268,
        "phaseHp": 375457,
        "phaseDefense": 1,
        "phaseAttackCumulative": 364532,
        "phaseHpCumulative": 5882153,
        "phaseDefenseCumulative": 19
      },
      {
        "sheetRow": 22,
        "phase": "Blue - Guardian",
        "evolutionLevel": 0,
        "phaseAndLevel": "Blue - Guardian:0",
        "titanLevel": 21,
        "phaseAttack": 23268,
        "phaseHp": 375457,
        "phaseDefense": 1,
        "phaseAttackCumulative": 387800,
        "phaseHpCumulative": 6257610,
        "phaseDefenseCumulative": 20
      },
      {
        "sheetRow": 23,
        "phase": "Blue - Guardian",
        "evolutionLevel": 1,
        "phaseAndLevel": "Blue - Guardian:1",
        "titanLevel": 22,
        "phaseAttack": 32317,
        "phaseHp": 521468,
        "phaseDefense": 2,
        "phaseAttackCumulative": 420117,
        "phaseHpCumulative": 6779078,
        "phaseDefenseCumulative": 22
      },
      {
        "sheetRow": 24,
        "phase": "Blue - Guardian",
        "evolutionLevel": 2,
        "phaseAndLevel": "Blue - Guardian:2",
        "titanLevel": 23,
        "phaseAttack": 32317,
        "phaseHp": 521468,
        "phaseDefense": 2,
        "phaseAttackCumulative": 452434,
        "phaseHpCumulative": 7300546,
        "phaseDefenseCumulative": 24
      },
      {
        "sheetRow": 25,
        "phase": "Blue - Guardian",
        "evolutionLevel": 3,
        "phaseAndLevel": "Blue - Guardian:3",
        "titanLevel": 24,
        "phaseAttack": 32317,
        "phaseHp": 521468,
        "phaseDefense": 2,
        "phaseAttackCumulative": 484751,
        "phaseHpCumulative": 7822014,
        "phaseDefenseCumulative": 26
      },
      {
        "sheetRow": 26,
        "phase": "Blue - Guardian",
        "evolutionLevel": 4,
        "phaseAndLevel": "Blue - Guardian:4",
        "titanLevel": 25,
        "phaseAttack": 32317,
        "phaseHp": 521468,
        "phaseDefense": 1,
        "phaseAttackCumulative": 517068,
        "phaseHpCumulative": 8343482,
        "phaseDefenseCumulative": 27
      },
      {
        "sheetRow": 27,
        "phase": "Blue - Guardian",
        "evolutionLevel": 5,
        "phaseAndLevel": "Blue - Guardian:5",
        "titanLevel": 26,
        "phaseAttack": 32317,
        "phaseHp": 521468,
        "phaseDefense": 2,
        "phaseAttackCumulative": 549385,
        "phaseHpCumulative": 8864950,
        "phaseDefenseCumulative": 29
      },
      {
        "sheetRow": 28,
        "phase": "Blue - Guardian",
        "evolutionLevel": 6,
        "phaseAndLevel": "Blue - Guardian:6",
        "titanLevel": 27,
        "phaseAttack": 32317,
        "phaseHp": 521468,
        "phaseDefense": 1,
        "phaseAttackCumulative": 581702,
        "phaseHpCumulative": 9386418,
        "phaseDefenseCumulative": 30
      },
      {
        "sheetRow": 29,
        "phase": "Blue - Guardian",
        "evolutionLevel": 7,
        "phaseAndLevel": "Blue - Guardian:7",
        "titanLevel": 28,
        "phaseAttack": 32317,
        "phaseHp": 521468,
        "phaseDefense": 1,
        "phaseAttackCumulative": 614019,
        "phaseHpCumulative": 9907886,
        "phaseDefenseCumulative": 31
      },
      {
        "sheetRow": 30,
        "phase": "Blue - Guardian",
        "evolutionLevel": 8,
        "phaseAndLevel": "Blue - Guardian:8",
        "titanLevel": 29,
        "phaseAttack": 32317,
        "phaseHp": 521468,
        "phaseDefense": 1,
        "phaseAttackCumulative": 646336,
        "phaseHpCumulative": 10429354,
        "phaseDefenseCumulative": 32
      },
      {
        "sheetRow": 31,
        "phase": "Blue - Guardian",
        "evolutionLevel": 9,
        "phaseAndLevel": "Blue - Guardian:9",
        "titanLevel": 30,
        "phaseAttack": 32317,
        "phaseHp": 521468,
        "phaseDefense": 1,
        "phaseAttackCumulative": 678653,
        "phaseHpCumulative": 10950822,
        "phaseDefenseCumulative": 33
      },
      {
        "sheetRow": 32,
        "phase": "Blue - Lacerator",
        "evolutionLevel": 0,
        "phaseAndLevel": "Blue - Lacerator:0",
        "titanLevel": 31,
        "phaseAttack": 32317,
        "phaseHp": 521468,
        "phaseDefense": 1,
        "phaseAttackCumulative": 710970,
        "phaseHpCumulative": 11472290,
        "phaseDefenseCumulative": 34
      },
      {
        "sheetRow": 33,
        "phase": "Blue - Lacerator",
        "evolutionLevel": 1,
        "phaseAndLevel": "Blue - Lacerator:1",
        "titanLevel": 32,
        "phaseAttack": 38780,
        "phaseHp": 625762,
        "phaseDefense": 1,
        "phaseAttackCumulative": 749750,
        "phaseHpCumulative": 12098052,
        "phaseDefenseCumulative": 35
      },
      {
        "sheetRow": 34,
        "phase": "Blue - Lacerator",
        "evolutionLevel": 2,
        "phaseAndLevel": "Blue - Lacerator:2",
        "titanLevel": 33,
        "phaseAttack": 38780,
        "phaseHp": 625762,
        "phaseDefense": 1,
        "phaseAttackCumulative": 788530,
        "phaseHpCumulative": 12723814,
        "phaseDefenseCumulative": 36
      },
      {
        "sheetRow": 35,
        "phase": "Blue - Lacerator",
        "evolutionLevel": 3,
        "phaseAndLevel": "Blue - Lacerator:3",
        "titanLevel": 34,
        "phaseAttack": 38780,
        "phaseHp": 625762,
        "phaseDefense": 1,
        "phaseAttackCumulative": 827310,
        "phaseHpCumulative": 13349576,
        "phaseDefenseCumulative": 37
      },
      {
        "sheetRow": 36,
        "phase": "Blue - Lacerator",
        "evolutionLevel": 4,
        "phaseAndLevel": "Blue - Lacerator:4",
        "titanLevel": 35,
        "phaseAttack": 38780,
        "phaseHp": 625762,
        "phaseDefense": 2,
        "phaseAttackCumulative": 866090,
        "phaseHpCumulative": 13975338,
        "phaseDefenseCumulative": 39
      },
      {
        "sheetRow": 37,
        "phase": "Blue - Lacerator",
        "evolutionLevel": 5,
        "phaseAndLevel": "Blue - Lacerator:5",
        "titanLevel": 36,
        "phaseAttack": 38780,
        "phaseHp": 625762,
        "phaseDefense": 2,
        "phaseAttackCumulative": 904870,
        "phaseHpCumulative": 14601100,
        "phaseDefenseCumulative": 41
      },
      {
        "sheetRow": 38,
        "phase": "Blue - Lacerator",
        "evolutionLevel": 6,
        "phaseAndLevel": "Blue - Lacerator:6",
        "titanLevel": 37,
        "phaseAttack": 38780,
        "phaseHp": 625762,
        "phaseDefense": 2,
        "phaseAttackCumulative": 943650,
        "phaseHpCumulative": 15226862,
        "phaseDefenseCumulative": 43
      },
      {
        "sheetRow": 39,
        "phase": "Blue - Lacerator",
        "evolutionLevel": 7,
        "phaseAndLevel": "Blue - Lacerator:7",
        "titanLevel": 38,
        "phaseAttack": 38780,
        "phaseHp": 625762,
        "phaseDefense": 2,
        "phaseAttackCumulative": 982430,
        "phaseHpCumulative": 15852624,
        "phaseDefenseCumulative": 45
      },
      {
        "sheetRow": 40,
        "phase": "Blue - Lacerator",
        "evolutionLevel": 8,
        "phaseAndLevel": "Blue - Lacerator:8",
        "titanLevel": 39,
        "phaseAttack": 38780,
        "phaseHp": 625762,
        "phaseDefense": 1,
        "phaseAttackCumulative": 1021210,
        "phaseHpCumulative": 16478386,
        "phaseDefenseCumulative": 46
      },
      {
        "sheetRow": 41,
        "phase": "Blue - Lacerator",
        "evolutionLevel": 9,
        "phaseAndLevel": "Blue - Lacerator:9",
        "titanLevel": 40,
        "phaseAttack": 38780,
        "phaseHp": 625762,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1059990,
        "phaseHpCumulative": 17104148,
        "phaseDefenseCumulative": 48
      },
      {
        "sheetRow": 42,
        "phase": "Purple - Trailblazer",
        "evolutionLevel": 0,
        "phaseAndLevel": "Purple - Trailblazer:0",
        "titanLevel": 41,
        "phaseAttack": 38780,
        "phaseHp": 625762,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1098770,
        "phaseHpCumulative": 17729910,
        "phaseDefenseCumulative": 50
      },
      {
        "sheetRow": 43,
        "phase": "Purple - Trailblazer",
        "evolutionLevel": 1,
        "phaseAndLevel": "Purple - Trailblazer:1",
        "titanLevel": 42,
        "phaseAttack": 45244,
        "phaseHp": 730055,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1144014,
        "phaseHpCumulative": 18459965,
        "phaseDefenseCumulative": 52
      },
      {
        "sheetRow": 44,
        "phase": "Purple - Trailblazer",
        "evolutionLevel": 2,
        "phaseAndLevel": "Purple - Trailblazer:2",
        "titanLevel": 43,
        "phaseAttack": 45244,
        "phaseHp": 730055,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1189258,
        "phaseHpCumulative": 19190020,
        "phaseDefenseCumulative": 54
      },
      {
        "sheetRow": 45,
        "phase": "Purple - Trailblazer",
        "evolutionLevel": 3,
        "phaseAndLevel": "Purple - Trailblazer:3",
        "titanLevel": 44,
        "phaseAttack": 45244,
        "phaseHp": 730055,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1234502,
        "phaseHpCumulative": 19920075,
        "phaseDefenseCumulative": 56
      },
      {
        "sheetRow": 46,
        "phase": "Purple - Trailblazer",
        "evolutionLevel": 4,
        "phaseAndLevel": "Purple - Trailblazer:4",
        "titanLevel": 45,
        "phaseAttack": 45244,
        "phaseHp": 730055,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1279746,
        "phaseHpCumulative": 20650130,
        "phaseDefenseCumulative": 58
      },
      {
        "sheetRow": 47,
        "phase": "Purple - Trailblazer",
        "evolutionLevel": 5,
        "phaseAndLevel": "Purple - Trailblazer:5",
        "titanLevel": 46,
        "phaseAttack": 45244,
        "phaseHp": 730055,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1324990,
        "phaseHpCumulative": 21380185,
        "phaseDefenseCumulative": 60
      },
      {
        "sheetRow": 48,
        "phase": "Purple - Trailblazer",
        "evolutionLevel": 6,
        "phaseAndLevel": "Purple - Trailblazer:6",
        "titanLevel": 47,
        "phaseAttack": 45244,
        "phaseHp": 730055,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1370234,
        "phaseHpCumulative": 22110240,
        "phaseDefenseCumulative": 62
      },
      {
        "sheetRow": 49,
        "phase": "Purple - Trailblazer",
        "evolutionLevel": 7,
        "phaseAndLevel": "Purple - Trailblazer:7",
        "titanLevel": 48,
        "phaseAttack": 45244,
        "phaseHp": 730055,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1415478,
        "phaseHpCumulative": 22840295,
        "phaseDefenseCumulative": 64
      },
      {
        "sheetRow": 50,
        "phase": "Purple - Trailblazer",
        "evolutionLevel": 8,
        "phaseAndLevel": "Purple - Trailblazer:8",
        "titanLevel": 49,
        "phaseAttack": 45244,
        "phaseHp": 730055,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1460722,
        "phaseHpCumulative": 23570350,
        "phaseDefenseCumulative": 66
      },
      {
        "sheetRow": 51,
        "phase": "Purple - Trailblazer",
        "evolutionLevel": 9,
        "phaseAndLevel": "Purple - Trailblazer:9",
        "titanLevel": 50,
        "phaseAttack": 45244,
        "phaseHp": 730055,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1505966,
        "phaseHpCumulative": 24300405,
        "phaseDefenseCumulative": 68
      },
      {
        "sheetRow": 52,
        "phase": "Purple - Inquisitor",
        "evolutionLevel": 0,
        "phaseAndLevel": "Purple - Inquisitor:0",
        "titanLevel": 51,
        "phaseAttack": 45244,
        "phaseHp": 730055,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1551210,
        "phaseHpCumulative": 25030460,
        "phaseDefenseCumulative": 70
      },
      {
        "sheetRow": 53,
        "phase": "Purple - Inquisitor",
        "evolutionLevel": 1,
        "phaseAndLevel": "Purple - Inquisitor:1",
        "titanLevel": 52,
        "phaseAttack": 51707,
        "phaseHp": 834349,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1602917,
        "phaseHpCumulative": 25864809,
        "phaseDefenseCumulative": 72
      },
      {
        "sheetRow": 54,
        "phase": "Purple - Inquisitor",
        "evolutionLevel": 2,
        "phaseAndLevel": "Purple - Inquisitor:2",
        "titanLevel": 53,
        "phaseAttack": 51707,
        "phaseHp": 834349,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1654624,
        "phaseHpCumulative": 26699158,
        "phaseDefenseCumulative": 74
      },
      {
        "sheetRow": 55,
        "phase": "Purple - Inquisitor",
        "evolutionLevel": 3,
        "phaseAndLevel": "Purple - Inquisitor:3",
        "titanLevel": 54,
        "phaseAttack": 51707,
        "phaseHp": 834349,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1706331,
        "phaseHpCumulative": 27533507,
        "phaseDefenseCumulative": 76
      },
      {
        "sheetRow": 56,
        "phase": "Purple - Inquisitor",
        "evolutionLevel": 4,
        "phaseAndLevel": "Purple - Inquisitor:4",
        "titanLevel": 55,
        "phaseAttack": 51707,
        "phaseHp": 834349,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1758038,
        "phaseHpCumulative": 28367856,
        "phaseDefenseCumulative": 78
      },
      {
        "sheetRow": 57,
        "phase": "Purple - Inquisitor",
        "evolutionLevel": 5,
        "phaseAndLevel": "Purple - Inquisitor:5",
        "phaseAttack": 51707,
        "phaseHp": 834349,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1809745,
        "phaseHpCumulative": 29202205,
        "phaseDefenseCumulative": 80
      },
      {
        "sheetRow": 58,
        "phase": "Purple - Inquisitor",
        "evolutionLevel": 6,
        "phaseAndLevel": "Purple - Inquisitor:6",
        "phaseAttack": 51707,
        "phaseHp": 834349,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1861452,
        "phaseHpCumulative": 30036554,
        "phaseDefenseCumulative": 82
      },
      {
        "sheetRow": 59,
        "phase": "Purple - Inquisitor",
        "evolutionLevel": 7,
        "phaseAndLevel": "Purple - Inquisitor:7",
        "phaseAttack": 51707,
        "phaseHp": 834349,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1913159,
        "phaseHpCumulative": 30870903,
        "phaseDefenseCumulative": 84
      },
      {
        "sheetRow": 60,
        "phase": "Purple - Inquisitor",
        "evolutionLevel": 8,
        "phaseAndLevel": "Purple - Inquisitor:8",
        "phaseAttack": 51707,
        "phaseHp": 834349,
        "phaseDefense": 2,
        "phaseAttackCumulative": 1964866,
        "phaseHpCumulative": 31705252,
        "phaseDefenseCumulative": 86
      },
      {
        "sheetRow": 61,
        "phase": "Purple - Inquisitor",
        "evolutionLevel": 9,
        "phaseAndLevel": "Purple - Inquisitor:9",
        "phaseAttack": 51707,
        "phaseHp": 834349,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2016573,
        "phaseHpCumulative": 32539601,
        "phaseDefenseCumulative": 88
      },
      {
        "sheetRow": 62,
        "phase": "Gold - Destruction",
        "evolutionLevel": 0,
        "phaseAndLevel": "Gold - Destruction:0",
        "phaseAttack": 51707,
        "phaseHp": 834349,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2068280,
        "phaseHpCumulative": 33373950,
        "phaseDefenseCumulative": 90
      },
      {
        "sheetRow": 63,
        "phase": "Gold - Destruction",
        "evolutionLevel": 1,
        "phaseAndLevel": "Gold - Destruction:1",
        "phaseAttack": 58171,
        "phaseHp": 938643,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2126451,
        "phaseHpCumulative": 34312593,
        "phaseDefenseCumulative": 92
      },
      {
        "sheetRow": 64,
        "phase": "Gold - Destruction",
        "evolutionLevel": 2,
        "phaseAndLevel": "Gold - Destruction:2",
        "phaseAttack": 58171,
        "phaseHp": 938643,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2184622,
        "phaseHpCumulative": 35251236,
        "phaseDefenseCumulative": 94
      },
      {
        "sheetRow": 65,
        "phase": "Gold - Destruction",
        "evolutionLevel": 3,
        "phaseAndLevel": "Gold - Destruction:3",
        "phaseAttack": 58171,
        "phaseHp": 938643,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2242793,
        "phaseHpCumulative": 36189879,
        "phaseDefenseCumulative": 96
      },
      {
        "sheetRow": 66,
        "phase": "Gold - Destruction",
        "evolutionLevel": 4,
        "phaseAndLevel": "Gold - Destruction:4",
        "phaseAttack": 58171,
        "phaseHp": 938643,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2300964,
        "phaseHpCumulative": 37128522,
        "phaseDefenseCumulative": 98
      },
      {
        "sheetRow": 67,
        "phase": "Gold - Destruction",
        "evolutionLevel": 5,
        "phaseAndLevel": "Gold - Destruction:5",
        "phaseAttack": 58171,
        "phaseHp": 938643,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2359135,
        "phaseHpCumulative": 38067165,
        "phaseDefenseCumulative": 100
      },
      {
        "sheetRow": 68,
        "phase": "Gold - Destruction",
        "evolutionLevel": 6,
        "phaseAndLevel": "Gold - Destruction:6",
        "phaseAttack": 58171,
        "phaseHp": 938643,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2417306,
        "phaseHpCumulative": 39005808,
        "phaseDefenseCumulative": 102
      },
      {
        "sheetRow": 69,
        "phase": "Gold - Destruction",
        "evolutionLevel": 7,
        "phaseAndLevel": "Gold - Destruction:7",
        "phaseAttack": 58171,
        "phaseHp": 938643,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2475477,
        "phaseHpCumulative": 39944451,
        "phaseDefenseCumulative": 104
      },
      {
        "sheetRow": 70,
        "phase": "Gold - Destruction",
        "evolutionLevel": 8,
        "phaseAndLevel": "Gold - Destruction:8",
        "phaseAttack": 58171,
        "phaseHp": 938643,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2533648,
        "phaseHpCumulative": 40883094,
        "phaseDefenseCumulative": 106
      },
      {
        "sheetRow": 71,
        "phase": "Gold - Destruction",
        "evolutionLevel": 9,
        "phaseAndLevel": "Gold - Destruction:9",
        "phaseAttack": 58171,
        "phaseHp": 938643,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2591819,
        "phaseHpCumulative": 41821737,
        "phaseDefenseCumulative": 108
      },
      {
        "sheetRow": 72,
        "phase": "Gold - Retribution",
        "evolutionLevel": 0,
        "phaseAndLevel": "Gold - Retribution:0",
        "phaseAttack": 58171,
        "phaseHp": 938643,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2649990,
        "phaseHpCumulative": 42760380,
        "phaseDefenseCumulative": 110
      },
      {
        "sheetRow": 73,
        "phase": "Gold - Retribution",
        "evolutionLevel": 1,
        "phaseAndLevel": "Gold - Retribution:1",
        "phaseAttack": 64634,
        "phaseHp": 1042936,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2714624,
        "phaseHpCumulative": 43803316,
        "phaseDefenseCumulative": 112
      },
      {
        "sheetRow": 74,
        "phase": "Gold - Retribution",
        "evolutionLevel": 2,
        "phaseAndLevel": "Gold - Retribution:2",
        "phaseAttack": 64634,
        "phaseHp": 1042936,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2779258,
        "phaseHpCumulative": 44846252,
        "phaseDefenseCumulative": 114
      },
      {
        "sheetRow": 75,
        "phase": "Gold - Retribution",
        "evolutionLevel": 3,
        "phaseAndLevel": "Gold - Retribution:3",
        "phaseAttack": 64634,
        "phaseHp": 1042936,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2843892,
        "phaseHpCumulative": 45889188,
        "phaseDefenseCumulative": 116
      },
      {
        "sheetRow": 76,
        "phase": "Gold - Retribution",
        "evolutionLevel": 4,
        "phaseAndLevel": "Gold - Retribution:4",
        "phaseAttack": 64634,
        "phaseHp": 1042936,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2908526,
        "phaseHpCumulative": 46932124,
        "phaseDefenseCumulative": 118
      },
      {
        "sheetRow": 77,
        "phase": "Gold - Retribution",
        "evolutionLevel": 5,
        "phaseAndLevel": "Gold - Retribution:5",
        "titanLevel": 1,
        "phaseAttack": 64634,
        "phaseHp": 1042936,
        "phaseDefense": 2,
        "phaseAttackCumulative": 2973160,
        "phaseHpCumulative": 47975060,
        "phaseDefenseCumulative": 120
      },
      {
        "sheetRow": 78,
        "phase": "Gold - Retribution",
        "evolutionLevel": 6,
        "phaseAndLevel": "Gold - Retribution:6",
        "titanLevel": 2,
        "phaseAttack": 64634,
        "phaseHp": 1042936,
        "phaseDefense": 2,
        "phaseAttackCumulative": 3037794,
        "phaseHpCumulative": 49017996,
        "phaseDefenseCumulative": 122
      },
      {
        "sheetRow": 79,
        "phase": "Gold - Retribution",
        "evolutionLevel": 7,
        "phaseAndLevel": "Gold - Retribution:7",
        "titanLevel": 3,
        "phaseAttack": 64634,
        "phaseHp": 1042936,
        "phaseDefense": 2,
        "phaseAttackCumulative": 3102428,
        "phaseHpCumulative": 50060932,
        "phaseDefenseCumulative": 124
      },
      {
        "sheetRow": 80,
        "phase": "Gold - Retribution",
        "evolutionLevel": 8,
        "phaseAndLevel": "Gold - Retribution:8",
        "titanLevel": 4,
        "phaseAttack": 64634,
        "phaseHp": 1042936,
        "phaseDefense": 2,
        "phaseAttackCumulative": 3167062,
        "phaseHpCumulative": 51103868,
        "phaseDefenseCumulative": 126
      },
      {
        "sheetRow": 81,
        "phase": "Gold - Retribution",
        "evolutionLevel": 9,
        "phaseAndLevel": "Gold - Retribution:9",
        "titanLevel": 5,
        "phaseAttack": 64634,
        "phaseHp": 1042936,
        "phaseDefense": 2,
        "phaseAttackCumulative": 3231696,
        "phaseHpCumulative": 52146804,
        "phaseDefenseCumulative": 128
      },
      {
        "sheetRow": 82,
        "phase": "Gold - Retribution",
        "evolutionLevel": 10,
        "phaseAndLevel": "Gold - Retribution:10",
        "titanLevel": 6,
        "phaseAttack": 64634,
        "phaseHp": 1042936,
        "phaseDefense": 2,
        "phaseAttackCumulative": 3296330,
        "phaseHpCumulative": 53189740,
        "phaseDefenseCumulative": 130
      }
    ],
    "phases": [
      {
        "phase": "Green - Enforcer",
        "minTitanLevel": 1,
        "maxTitanLevel": 10,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Green - Explorer",
        "minTitanLevel": 11,
        "maxTitanLevel": 20,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Blue - Guardian",
        "minTitanLevel": 21,
        "maxTitanLevel": 30,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Blue - Lacerator",
        "minTitanLevel": 31,
        "maxTitanLevel": 40,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Purple - Trailblazer",
        "minTitanLevel": 41,
        "maxTitanLevel": 50,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Purple - Inquisitor",
        "minTitanLevel": 51,
        "maxTitanLevel": 55,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Gold - Destruction",
        "minTitanLevel": null,
        "maxTitanLevel": null,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Gold - Retribution",
        "minTitanLevel": 1,
        "maxTitanLevel": 6,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10
        ]
      }
    ]
  }
};
